export default __webpack_public_path__ + "static/media/list.2cae1fa0.svg";